var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostMentionNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.75 20.25V29.25C33.75 31.7352 35.7647 33.75 38.25 33.75C40.7353 33.75 42.75 31.7352 42.75 29.25V27C42.75 23.6298 41.6693 20.3486 39.6661 17.6384C37.663 14.9282 34.8427 12.932 31.6209 11.9432C28.399 10.9544 24.9448 11.025 21.7661 12.1449C18.5875 13.2647 15.852 15.3747 13.9614 18.1646C12.0708 20.9545 11.1253 24.2772 11.2632 27.6445C11.4011 31.0118 12.6155 34.2462 14.7279 36.8722C16.8403 39.4981 19.7397 41.3772 22.9993 42.2333C26.2589 43.0895 29.7066 42.8774 32.8368 41.6284M33.75 27C33.75 30.7279 30.7279 33.75 27 33.75C23.2721 33.75 20.25 30.7279 20.25 27C20.25 23.272 23.2721 20.25 27 20.25C30.7279 20.25 33.75 23.272 33.75 27Z",
    stroke: "#00AFF0",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostMentionNotification);
export default __webpack_public_path__ + "static/media/PostMentionNotification.28ef2fda2616cabe840d68b98aaae8bf.svg";
export { ForwardRef as ReactComponent };